var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "transition",
    { attrs: { name: "fade", mode: "out-in" } },
    [
      _c(_vm.viewType, {
        key: _vm.viewType,
        tag: "component",
        attrs: {
          mode: "signup",
          context: _vm.context,
          "flow-type": _vm.currentFlow,
        },
        on: { update: _vm.updateFlow },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }